import { useState } from "react";
import Pic from "../../../assets/img/NewsImgs/tabligh4.jpg"
import Clock from "../../../assets/icon/NewsIcons/NewsClockMain2"
import Right from "../../../assets/icon/NewsIcons/NewsRightBold2"
import Left from "../../../assets/icon/NewsIcons/NewsLeftBold2"
import Bottom from "../../../assets/icon/NewsIcons/NewsBottom2"
import ImageGallery from "react-image-gallery";


const images = [
    {
        original: require("../../../assets/img/NewsImgs/tabligh4.jpg"),
        originalAlt: "1تصویر",
        text: "عکس یادگاری نمایندگان مجلس دهم در روز آخر کاری",
        time: "50 دقیقه پیش",
      
    },
    {
        original: require("../../../assets/img/NewsImgs/tabligh4.jpg"),
        originalAlt: "50 دقیقه پیش",
    },
    {
        original: require("../../../assets/img/NewsImgs/tabligh4.jpg"),
        originalAlt: "50 دقیقه پیش",
    },
    {
        original: require("../../../assets/img/NewsImgs/tabligh4.jpg"),
        originalAlt: "50 دقیقه پیش",
    },
  ];


const MyCollection = [
    {
        label: "Picture1",
        imgPath:
            "tabligh4.jpg",
        text: "عکس یادگاری نمایندگان مجلس دهم در روز آخر کاری",
        time: "20 دقیقه پیش",
    },
    {
        label: "Picture3",
        imgPath:
            "tabligh4.jpg",
        text: "۴۱ هزار میلیارد تومان از مطالبات پتروشیمی‌های بوشهر وصول شد",
        time: "35 دقیقه پیش",
    },
    {
        label: "Picture4",
        imgPath:
            "tabligh4.jpg",
        text: "قیمت ارزهای مبادله ای امروز 9 خرداد ؛ دلار رشد کرد!",
        time: "50 دقیقه پیش",
    },
];

const TopNewsImg2 = () => {



    const CollectionSize = MyCollection.length;
    const [index, setActiveStep] = useState(0);

    const goToNextPicture = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const goToLastPicture = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };


    return(
        <div>
            <div className="h-[387px] bg-mainColor2 md:h-[220px]"></div>
            <div>
                
                <div className=" relative mx-[74px] md:mx-auto md:w-[90%] ">
                    <div className=" h-[568px] absolute opacity-100 w-full -mt-[387px] md:-mt-[200px] md:h-[220px]" >
                    
                      
                        <img className="w-full h-full rounded-3xl" src={require("../../../assets/img/NewsImgs/"+ MyCollection[index].imgPath)} alt={MyCollection[index].label} />
                    </div>
                    <div className=" h-[568px] absolute rounded-3xl w-full -mt-[387px] opacity-90 bg-gradient-to-t from-black md:-mt-[200px] md:h-[220px]">
                    </div>
                    <div className="h-[568px] absolute w-full -mt-[387px] flex justify-center items-end md:-mt-[200px] md:h-[220px]">
                        <img className="w-[200px] -mb-[1px] h-[40px]" src={Pic} alt="تصویر" />
                        
                        
                    </div>
                    
                    <div className=" h-[568px] absolute w-full -mt-[387px]">
                    </div> 
                    <div className=" h-[568px] absolute w-full -mt-[387px] md:-mt-[200px] md:h-[220px]">
                        <div className="w-full h-full flex flex-col justify-end">
                        <div className="flex justify-between items-center mx-[25px] mb-[122px] md:mx-[10px] md:mb-[0px]">
                            <button onClick={goToLastPicture} disabled={index === 0}><Right width="16" height="28" font="4" /></button>
                            <button onClick={goToNextPicture} disabled={index === CollectionSize - 1}><Left width="16" height="28" font="4" /></button>
                        </div>
                        <div className="mx-[25px] ml-5 md:mr-[10px]">
                        <a href="/single"> 
                <p className="text-white font-IRANYekanMedium text-[30px] md:text-[15px]" >
                {MyCollection[index].text}
                </p>
                </a>
            </div>
            <div className="flex items-center justify-start mx-[25px] mb-[45px] mt-[4px] md:mr-[10px]">
                <div className="ml-2">
                    <Clock/>

                </div>
                <div>
                <p className="text-white font-IRANYekanLight text-[15px] md:text-[10px]" >
                {MyCollection[index].time}
                </p>

                </div>

            </div>

                        </div>
                    </div>
                    
                    
                </div>
                
            </div>
            <div className="flex justify-center -mt-[15px] items-end pb-[1px] h-[200px] w-full md:h-[30px]">
            <div className="absolute "><Bottom className="md:w-[12px]"/></div>

            </div>
        </div>
    )
}

export default TopNewsImg2;